import useBreakpoints from "neetocommons/react-utils/useBreakpoints";
import { CloseCircle, User } from "neetoicons";
import { Profile } from "neetoteam";
import { Dropdown as NeetoUIDropdown } from "neetoui";
import { useTranslation } from "react-i18next";

import MenuButton from "./MenuButton";

import { DELETE_WORKSPACE_URL } from "../../constants";

const { Menu, MenuItem } = NeetoUIDropdown;

const ProfileExpandMenu = ({ profileInfo }) => {
  const { t } = useTranslation();
  const { isSize } = useBreakpoints();
  const [, setIsProfilePaneOpen] = Profile.usePaneState();

  const isMobile = isSize("mobile");

  return (
    <NeetoUIDropdown
      closeOnSelect={false}
      customTarget={<MenuButton {...{ profileInfo }} />}
      interactiveDebounce={30}
      offset={[0, 5]}
      position={isMobile ? "bottom" : "right"}
      trigger="all"
      zIndex={99999}
    >
      <Menu>
        <MenuItem.Button
          className="neeto-molecules-menu-sublist__item-btn"
          data-testid="profile-my-profile-button"
          prefix={<User size={18} />}
          onClick={() => setIsProfilePaneOpen(true)}
        >
          {t("neetoMolecules.sidebar.myProfile")}
        </MenuItem.Button>
        {window.globalProps?.user?.isOwner && (
          <MenuItem.Button
            className="neeto-molecules-menu-sublist__item-btn"
            data-testid="profile-cancel-account-button"
            href={DELETE_WORKSPACE_URL}
            prefix={<CloseCircle size={18} />}
            rel="noreferrer"
            style="text"
            target="_blank"
          >
            {t("neetoMolecules.sidebar.cancelAccount")}
          </MenuItem.Button>
        )}
      </Menu>
    </NeetoUIDropdown>
  );
};

export default ProfileExpandMenu;
